/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Injectable } from '@angular/core';
import { User, Client, FilterPreference } from '../model';
import { Preference } from '../model/preference';
import { BehaviorSubject } from 'rxjs';
import { Tag } from '../model/tag';

@Injectable()
export class DashboardService {

  users = new BehaviorSubject<User[]>([]);
  users$ = this.users.asObservable();

  clients = new BehaviorSubject<Client[]>([]);
  clients$ = this.clients.asObservable();

  preferences = new BehaviorSubject<Preference[]>([]);
  preferences$ = this.preferences.asObservable();

  savedPreferences = new BehaviorSubject<Preference[]>([]);
  savedPreferences$ = this.savedPreferences.asObservable();

  preference = new BehaviorSubject<FilterPreference>(null);
  preference$ = this.preference.asObservable();

  processors = new BehaviorSubject<User[]>([]);
  processors$ = this.processors.asObservable();

  researchAnalysts = new BehaviorSubject<User[]>([]);
  researchAnalysts$ = this.researchAnalysts.asObservable();

  financialAnalysts = new BehaviorSubject<User[]>([]);
  financialAnalysts$ = this.financialAnalysts.asObservable();

  seniorAnalysts = new BehaviorSubject<User[]>([]);
  seniorAnalysts$ = this.seniorAnalysts.asObservable();

  tags = new BehaviorSubject<Tag[]>([]);
  tags$ = this.tags.asObservable();

  //Report Ea
  eqprocessors = new BehaviorSubject<User[]>([]);
  eqprocessors$ = this.eqprocessors.asObservable();

  eqresearchAnalysts = new BehaviorSubject<User[]>([]);
  eqresearchAnalysts$ = this.eqresearchAnalysts.asObservable();

  eqAppraiser = new BehaviorSubject<User[]>([]);
  eqAppraiser$ = this.eqAppraiser.asObservable();

  eqReviewer = new BehaviorSubject<User[]>([]);
  eqReviewer$ = this.eqReviewer.asObservable();

  setUsers(dataUsers: User[]): void {
    this.users.next(dataUsers);
  }

  setClients(dataClients: Client[]): void {
    this.clients.next(dataClients);
  }

  setPreferences(dataPreferences: Preference[]): void {
    this.preferences.next(dataPreferences);
  }
}
